import systemMutations from './mutations.js';
import systemActions from './actions.js';
import systemGetters from './getters.js';

export default {
    namespaced: true,
    state() {
        return {
            erppartition: 'erp',
            partition: 'cml',
            language: 'eng'
        }
    },
    mutations: systemMutations,
    actions: systemActions,
    getters: systemGetters
};
